import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { NewCfrRequest, NewCfrResponse, CfrClientModel } from "../../models/cfr/cfr.models";
import { CfrRoutes } from "../../constants/cfr/cfr.constants";
import { LinkedIncidentModel, LinkedPscInspectionModel } from "../../models/fbrs/fbr.models";

@autoinject
export class CfrService {
    
    constructor(private requestClient: RequestClientService) { }

    save(request: NewCfrRequest): Promise<NewCfrResponse> {
        return this.requestClient.postFormData(CfrRoutes.Save, request);
    }

    getCfr(id: number): Promise<CfrClientModel> {
        return this.requestClient.get(`${CfrRoutes.GetCfr}/${id}`, {});
    }
    
    unlinkIncident(cfrId: number, incidentId: number): Promise<void> {
        return this.requestClient.post(`${CfrRoutes.UnlinkIncident}/${cfrId}/${incidentId}`, {}, {});
    }

    linkToIncident(cfrId: number, incidentIds: number[]): Promise<LinkedIncidentModel[]> {
        return this.requestClient.post(`${CfrRoutes.LinkToIncident}/${cfrId}`, {}, {
            incidentIds: incidentIds
        });
    }
    
    unlinkPscInspection(cfrId: number, pscInspectionId: number): Promise<void> {
        return this.requestClient.post(`${CfrRoutes.UnlinkPscInspection}/${cfrId}/${pscInspectionId}`, {}, {});
    }

    linkToPscInspection(cfrId: number, pscInspectionIds: number[]): Promise<LinkedPscInspectionModel[]> {
        return this.requestClient.post(`${CfrRoutes.LinkToPscInspection}/${cfrId}`, {}, {
            pscInspectionIds: pscInspectionIds
        });
    }

    changeStatus(id: number, cfrStatusId: number, comments: string, meta: string, subtaskTypes: number[], statusSnippet: string): Promise<void> {
        return this.requestClient.post(CfrRoutes.ChangeStatus, {}, {
            id: id,
            comments: comments,
            statusId: cfrStatusId,
            meta: meta,
            subtaskTypes: subtaskTypes,
            statusSnippet: statusSnippet
        });
    }
}